export const MOBILE_VIEW_BRAKEPOINT = 420;
export const MARGIN_SIZE = 28;
export const MAX_ITEM_SIZE = 120;
export const ITEMS_IN_ROW = 3;
export const QUESTIONMARK_STRING = 'questionmark';
